/* eslint import/prefer-default-export: 0 */

import remote from './remote';

export function submitSuperoverScore(data) {
  return remote.post('superover/claim', data);
}
